import { useState } from 'react';

import editCheck from '../../../assets/edit-check.png';
import { Button } from '@/components/Elements';
import { useAuth } from '@/lib/auth';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

const AddLoyaltyPoints = ({ corpData, setAddLoyalty, closeDialog }: any) => {
    const { user }: any = useAuth();

    const [loyaltyPoints, setLoyaltyPoints] = useState('');

    // function to get cent price
    const toCent = (amount: any) => {
        const cents = amount * 100;
        return Number(cents);
    };

    ////////////

    const handleSubmit = async () => {
        const updateData = {
            corporate_id: corpData?.id,
            admin_id: user?.data?.id,
            applied_points: loyaltyPoints,
        };

        await axios.post(`v1/credit-loyalty-points-corporate`, updateData);

        showSuccess();
        closeDialog();
        setAddLoyalty(null);
    };

    const showSuccess = () => {
        useNotificationStore.getState().addNotification({
            type: 'success',
            title: 'Success',
            message: 'Loyalty Points Credited Successfully!',
        });
    };

    return (
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                        Add Loyalty Points
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                            closeDialog();
                            setAddLoyalty(null);
                        }}
                    ></button>
                </div>
                <div className="modal-body">
                    <div className="col-md-12">
                        <label htmlFor="credit" className="control-label">
                            Enter The Loyalty Points
                        </label>
                        <div className="form-group">
                            <input
                                type="text"
                                name="credit"
                                className="form-control"
                                placeholder="100"
                                value={loyaltyPoints}
                                onChange={(e) => {
                                    setLoyaltyPoints(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className="modal-footer"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '1rem',
                    }}
                >
                    <Button
                        type="submit"
                        startIcon={<img src={editCheck} alt="editCheck" />}
                        style={{ width: 'fit-content' }}
                        onClick={() => handleSubmit()}
                    >
                        Add Loyalty Points
                    </Button>
                    <Button
                        variant="secondary"
                        style={{ width: 'fit-content' }}
                        onClick={() => {
                            closeDialog();
                            setAddLoyalty(null);
                        }}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AddLoyaltyPoints;
